var map = {
	"./icon_instagram_justify_0.png": "a72cd",
	"./icon_instagram_justify_1.png": "914d",
	"./icon_instagram_justify_2.png": "0457",
	"./icon_instagram_justify_center.png": "ce6b",
	"./icon_instagram_justify_left.png": "60c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16eb";